module.exports = __webpack_public_path__ + "static/megrooms-9fb5b93743c14af37916fd3760a80b68.jpg";